import * as Sentry from "@sentry/vue";

require('./bootstrap-scheduler');
import Vue from 'vue';
import VueMobileDetection from 'vue-mobile-detection';
import browserDetect from "vue-browser-detect-plugin";
import { createInertiaApp } from '@inertiajs/inertia-vue'
import { Inertia } from "@inertiajs/inertia";
import VueWindowSize from 'vue-window-size';
import VueNoty from 'vuejs-noty';
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from 'v-click-outside'

import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faCaretRight, faPhone, faVideo, faBuilding, faCheckCircle, faSquareArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons'
import { faChevronRight, faChevronLeft, faClock, faCalendarDays, faGlobe, faUser } from '@fortawesome/pro-light-svg-icons'
import { BrowserTracing } from "@sentry/tracing";
import { CaptureConsole } from "@sentry/integrations";

/* import plugins */
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input'
import translations from "./translations";

import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjsMixin from './mixins/dayjs'

/* add icons to the library */
library.add(faArrowLeft, faSpinnerThird, faChevronRight, faChevronLeft, faClock, faCalendarDays, faGlobe, faUser, faCaretRight, faPhone, faVideo, faBuilding, faCheckCircle, faSquareArrowRight)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueWindowSize);
Vue.use(VueMobileDetection);
Vue.use(browserDetect);
Vue.use(VueNoty, {
    theme: 'light'
});
Vue.use(VueAxios, axios)

Vue.use(vClickOutside)
Vue.prototype.$route = route

Vue.use(translations)

/* dayjs */
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(utc)
dayjs.extend(timezone)

Vue.prototype.$dayjs = dayjs

Vue.mixin(dayjsMixin)
/* */

Sentry.init({
    Vue,
    dsn: "https://00ec538fd2584063b7ceea90a7e709d4@o4504806779322368.ingest.sentry.io/4504851169345536",
    integrations: [
        new BrowserTracing({
            tracePropagationTargets: ["universe.nomadas.test", "universe.live.nomadas.cloud", "universe.nomadasexperience.com", /^\//],
        }),
        new CaptureConsole({
            levels: ['error']
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});
createInertiaApp({
    resolve: name => import(`./Pages/${name}`),
    setup({ el, app, props }) {
        new Vue({
            render: h => h(app, props),
        }).$mount(el)

        // Initialize plugins
        window.ipapiConfig = props.props.initialPage.props.ipapi;
        window.intlTelInput = intlTelInput;

        Inertia.on('invalid', (event) => {
            const status = event.detail.response.status;
            if (status === 500) {
                event.preventDefault();
                const pageProps = Inertia.page.props;

                const errorMessage = Vue.prototype.__.call(
                    { $page: Inertia.page }, 
                    'agenda-event.something_happened'
                );

                if (!pageProps.flash) {
                    Vue.set(pageProps, 'flash', {});
                }

                Vue.set(pageProps.flash, 'error', errorMessage);
            }
        });
    },
});
